<script setup>
useSeoMeta({
  title: 'Barrierefreiheit',
});
</script>

<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title tag="h1" class="text-wrap">Erklärung zur Barrierefreiheit</v-card-title>
          <v-card-text>
            <div class="text-body-1 mb-2">
              Das Bundesministerium für Land- und Forstwirtschaft, Klima- und Umweltschutz, Regionen
              und Wasserwirtschaft (BMLUK) ist bemüht, seine Websites im Einklang mit dem
              Bundesgesetz über den barrierefreien Zugang zu Websites und mobilen Anwendungen des
              Bundes (Web-Zugänglichkeits-Gesetz – WZG), BGBl. I Nr. 59/2019 idgF, barrierefrei
              zugänglich zu machen.
            </div>
            <div class="text-body-1 mb-2">
              Diese Erklärung zur Barrierefreiheit gilt für die Web-Applikation „EUDR Meldung“ zur
              Abgabe der vereinfachten Erklärung im Rahmen der EU-Entwaldungsverordnung.
            </div>

            <h2 class="text-h6 mt-4 mb-2">Stand der Vereinbarkeit mit den Anforderungen</h2>
            <div class="text-body-1 mb-2">
              Diese Website ist wegen der folgenden Unvereinbarkeiten und Ausnahmen teilweise mit
              der Konformitätsstufe AA der
              <a href="https://www.w3.org/TR/WCAG21/" target="_blank" class="text-primary"
                >„Richtlinien für barrierefreie Webinhalte – WCAG 2.1“</a
              >
              beziehungsweise mit dem geltenden Europäischen Standard EN 301 549 V3.2.1 (2021-03)
              nach der Richtlinie (EU) 2016/2102 des Europäischen Parlaments und des Rates
              vereinbar.
            </div>

            <h2 class="text-h6 mt-4 mb-2">Nicht barrierefreie Inhalte</h2>
            <div class="text-body-1 mb-2">
              Die nachstehend aufgeführten Inhalte sind aus den folgenden Gründen nicht
              barrierefrei:
            </div>
            <h3 class="text-subtitle-1 font-weight-bold mt-2 mb-1">
              a. Unvereinbarkeit mit den Barrierefreiheitsbestimmungen
            </h3>
            <ul class="text-body-1 pl-4 mb-2">
              <li class="mb-1">
                Die Anleitungsvideos auf der Startseite haben derzeit keine Untertitel (WCAG 2.1
                Erfolgskriterium 1.2.2). Untertitel werden ergänzt. Bis dahin erhalten Sie Auskunft
                zu den Inhalten der Videos unter
                <a href="mailto:service.entwaldung@bmluk.gv.at" class="text-primary"
                  >service.entwaldung@bmluk.gv.at</a
                >.
              </li>
            </ul>
            <h3 class="text-subtitle-1 font-weight-bold mt-2 mb-1">
              b. Die Inhalte fallen nicht in den Anwendungsbereich der anwendbaren
              Rechtsvorschriften
            </h3>
            <ul class="text-body-1 pl-4 mb-2">
              <li class="mb-1">
                Die Karten zum Erfassen und Anzeigen von Erzeugungsorten sind Online-Karten, die
                nicht der Navigation dienen, und gemäß § 2 Abs. 3 lit. d WZG ausgenommen. Statt
                Erzeugungsorte in der Karte einzuzeichnen, können Sie als Lokalisierung die
                Postanschrift angeben oder Flächen als GeoJSON-Datei laden. Bei Anmeldung über eAMA
                werden die Flächen aus dem Mehrfachantrag übernommen.
              </li>
            </ul>
            <div class="text-body-1 mb-2">
              Wenn Sie Informationen zu nicht barrierefreien Inhalten in barrierefreier Form
              benötigen, wenden Sie sich bitte an
              <a href="mailto:service.entwaldung@bmluk.gv.at" class="text-primary"
                >service.entwaldung@bmluk.gv.at</a
              >.
            </div>

            <h2 class="text-h6 mt-4 mb-2">Erstellung der Erklärung zur Barrierefreiheit</h2>
            <div class="text-body-1 mb-2">
              Diese Erklärung wurde am 30. Oktober 2026 erstellt. Die Erklärung wurde auf Grundlage
              einer vom BMLUK durchgeführten Selbstbewertung erstellt.
            </div>
            <div class="text-body-1 mb-2">
              Diese Erklärung wurde zuletzt am 30. Oktober 2026 überprüft.
            </div>

            <h2 class="text-h6 mt-4 mb-2">Feedback und Kontaktangaben</h2>
            <div class="text-body-1 mb-2">
              Wenn Ihnen Mängel in Bezug auf die barrierefreie Gestaltung dieser Applikation
              auffallen, teilen Sie uns diese bitte per E-Mail an
              <a href="mailto:service.entwaldung@bmluk.gv.at" class="text-primary"
                >service.entwaldung@bmluk.gv.at</a
              >
              mit.
            </div>

            <h2 class="text-h6 mt-4 mb-2">Durchsetzungsverfahren</h2>
            <div class="text-body-1 mb-2">
              Bei nicht zufriedenstellenden Antworten aus oben genannter Kontaktmöglichkeit können
              Sie sich mittels Beschwerde an die Beschwerdestelle der Österreichischen
              Forschungsförderungsgesellschaft mbH (FFG) wenden. Die FFG nimmt über das
              <a
                href="https://www.digitalbarrierefrei.at/de/beschwerdestelle/kontaktformular-beschwerdestelle"
                target="_blank"
                class="text-primary"
                >Kontaktformular der Beschwerdestelle</a
              >
              Beschwerden auf elektronischem Weg entgegen.
            </div>
            <div class="text-body-1 mb-2">
              Die Beschwerden werden von der FFG dahingehend geprüft, ob sie sich auf Verstöße gegen
              die Vorgaben des Web-Zugänglichkeits-Gesetzes, insbesondere Mängel bei der Einhaltung
              der Barrierefreiheitsanforderungen, durch den Bund oder einer ihm zuordenbaren
              Einrichtung beziehen.
            </div>
            <div class="text-body-1 mb-2">
              Sofern die Beschwerde berechtigt ist, hat die FFG dem Bund oder den betroffenen
              Rechtsträgern Handlungsempfehlungen auszusprechen und Maßnahmen vorzuschlagen, die der
              Beseitigung der vorliegenden Mängel dienen.
            </div>
            <div class="text-body-1 mb-2">
              <a
                href="https://www.digitalbarrierefrei.at/de/beschwerde-einreichen/informationen-zum-beschwerdeprozess"
                target="_blank"
                class="text-primary"
                >Weitere Informationen zum Beschwerdeverfahren</a
              >
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
